import { grey, blueGrey } from '@mui/material/colors';

const customStyle = () =>{
    return {
      palette: {
        primary: {
          // Purple and green play nicely together.
          main: grey[700],
        },
        secondary: {
          // This is green.A700 as hex.
          main: blueGrey[500],
        },
        success: {
          main: "#fff"
        }
      },
        typography: {
          fontFamily: [
            'Montserrat',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
          ].join(','),
          body2: {
            fontSize: "12px",
            fontWeight: '600',
            fontFamily: 'Montserrat',
            //padding: '10px'
          },
          body1: {
            fontSize: "12px",
            fontWeight: '600',
            fontFamily: 'Montserrat'
          },
          subtitle1: {
            fontSize: "21px",
            fontWeight: 'bold',
            fontFamily: 'Montserrat'
          },
          subtitle2: {
            fontSize: "11px",
            fontFamily: 'Montserrat'
          },
          h1: {
            fontSize: "1.5rem",
            fontWeight: 'bold',
            fontFamily: 'Montserrat',
            padding: '10px',
            //color: "#fff"
          },
          h2: {
            fontSize: "1rem",
            fontWeight: 'bold',
            fontFamily: 'Montserrat',
            padding: '10px',
            color: "#828282"
          },
          h3: {
            fontSize: "12px",
            fontWeight: '600',
            fontFamily: 'Montserrat',
            borderBottom: 'solid 1px #f0f4f9',
            padding: '10px'
          },
          h4: {
            fontSize: "12px",
            fontWeight: '600',
            fontFamily: 'Montserrat',
          },
          h5: {
            fontSize: "14px",
            fontWeight: '600',
            fontFamily: 'Montserrat'
          },
          h6: {
            fontSize: "16px",
            fontWeight: '400',
            fontFamily: 'Montserrat'
          }
        }
      }
}

export default customStyle;